import {
  IEditBehaviorSpecifiable, instanceOfIEditBehaviorSpecifiable,
  IPageExtendBehaviorSpecifiable, instanceOfIPageExtendBehaviorSpecifiable,
  IInputMethodBehaviorSpecifiable, instanceOfIInputMethodBehaviorSpecifiable,
  ITurnedTextStyleSpecifiable, instanceOfITurnedTextStyleSpecifiable,
  INumberStyleSpecifiable, instanceOfINumberStyleSpecifiable,
  INumberRangeAlertBehaviorSpecifiable, instanceOfINumberRangeAlertBehaviorSpecifiable,
  IFocusBehaviorSpecifiable, instanceOfIFocusBehaviorSpecifiable,
  IPaintStyleOnEditingSpecifiable, instanceOfIPaintStyleOnEditingSpecifiable,
  IItemsStyleSpecifiable, instanceOfIItemsStyleSpecifiable,
  IItemGroupSelectBehaviorSpecifiable, instanceOfIItemGroupSelectBehaviorSpecifiable,
  IHisInformationItemDefaultSelectBehaviorSpecifiable, instanceOfIHisInformationItemDefaultSelectBehaviorSpecifiable,
  IHospitalizedHisInformationItemSelectBehaviorSpecifiable, instanceOfIHospitalizedHisInformationItemSelectBehaviorSpecifiable,
  IUserDefinedInformationSourceSpecifiable, instanceOfIUserDefinedInformationSourceSpecifiable,
  IUserDefinedItemSelectBehaviorSpecifiable, instanceOfIUserDefinedItemSelectBehaviorSpecifiable,
  IDesignatedDoctorInformationSourceSpecifiable, instanceOfIDesignatedDoctorInformationSourceSpecifiable,
  ICopyLinkedTextsBehaviorSpecifiable, instanceOfICopyLinkedTextsBehaviorSpecifiable,
  IQuestionnaireSpecifiable, instanceOfIQuestionnaireSpecifiable,
  TextObjectKinds,
} from "../../../../documaker/domain/format/objects";
import { IStandardTextDrawableObject, instanceOfIStandardTextDrawableObject } from "./IStandardTextDrawableObject";

export interface ITextObject extends
IStandardTextDrawableObject,
IEditBehaviorSpecifiable,
IPageExtendBehaviorSpecifiable,
IInputMethodBehaviorSpecifiable,
ITurnedTextStyleSpecifiable,
INumberStyleSpecifiable,
INumberRangeAlertBehaviorSpecifiable,
IFocusBehaviorSpecifiable,
IPaintStyleOnEditingSpecifiable,
IItemsStyleSpecifiable,
IItemGroupSelectBehaviorSpecifiable,
IHisInformationItemDefaultSelectBehaviorSpecifiable,
IHospitalizedHisInformationItemSelectBehaviorSpecifiable,
IUserDefinedInformationSourceSpecifiable,
IUserDefinedItemSelectBehaviorSpecifiable,
IDesignatedDoctorInformationSourceSpecifiable,
ICopyLinkedTextsBehaviorSpecifiable,
IQuestionnaireSpecifiable {
  objectKind: TextObjectKinds;
  // TODO: 独自要素の実装.
}

export function instanceOfITextObject(instance: any): instance is ITextObject {
  return instance
      && (instance.objectKind !== undefined)
      && instanceOfIEditBehaviorSpecifiable(instance)
      && instanceOfIPageExtendBehaviorSpecifiable(instance)
      && instanceOfIInputMethodBehaviorSpecifiable(instance)
      && instanceOfITurnedTextStyleSpecifiable(instance)
      && instanceOfINumberStyleSpecifiable(instance)
      && instanceOfINumberRangeAlertBehaviorSpecifiable(instance)
      && instanceOfIFocusBehaviorSpecifiable(instance)
      && instanceOfIPaintStyleOnEditingSpecifiable(instance)
      && instanceOfIItemsStyleSpecifiable(instance)
      && instanceOfIItemGroupSelectBehaviorSpecifiable(instance)
      && instanceOfIHisInformationItemDefaultSelectBehaviorSpecifiable(instance)
      && instanceOfIHospitalizedHisInformationItemSelectBehaviorSpecifiable(instance)
      && instanceOfIUserDefinedInformationSourceSpecifiable(instance)
      && instanceOfIUserDefinedItemSelectBehaviorSpecifiable(instance)
      && instanceOfIDesignatedDoctorInformationSourceSpecifiable(instance)
      && instanceOfICopyLinkedTextsBehaviorSpecifiable(instance)
      && instanceOfIQuestionnaireSpecifiable(instance)
      && instanceOfIStandardTextDrawableObject<ITextObject>(instance, "text");
}
